<template>
  <div class="first-month-promotion-cancel">
    <standard-content
      :payloads="{
        title: title,
        description: description,
      }"
    >
      <template #icon>
        <i class="icon"></i>
      </template>
      <template #buttons>
        <button
          type="button"
          class="button button-primary"
          @click.prevent="onClickProcess"
        >
          {{ confirmText }}
        </button>
        <button
          type="button"
          class="button button-gray"
          @click="$emit('on-cancel')"
        >
          취소
        </button>
      </template>
    </standard-content>
  </div>
</template>
<script setup>
  import { defineProps, defineEmits } from 'vue'
  import StandardContent from '@/views/popup/fragments/StandardContent'
  import { getTextBreaks } from '@/common/util/string-manipulation/get-text-breaks'
  import { PROMOTION_100_CANCEL_VOUCHER } from '@/common/util/voucher/const'
  import { FIRST_MONTH_PROMOTION_CONFIRM } from '@/common/resources/const'
  import { EventBus } from '@/components/eventbus/EventBus'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })
  defineEmits(['on-cancel'])

  const title = getTextBreaks(
    props.payloads?.title || PROMOTION_100_CANCEL_VOUCHER.TITLE,
  )
  const description = getTextBreaks(
    props.payloads?.description || PROMOTION_100_CANCEL_VOUCHER.DESCRIPTION,
  )
  const confirmText =
    props.payloads?.confirmText || PROMOTION_100_CANCEL_VOUCHER.CONFIRM_TEXT

  const onClickProcess = () => {
    EventBus.$emit(FIRST_MONTH_PROMOTION_CONFIRM, {
      isSuccess: true,
      payloads: props.payloads,
    })
  }
</script>
<style scoped lang="scss">
  .first-month-promotion-cancel {
    overflow-y: auto;
    .icon {
      display: block;
      margin: 0 auto 40px;
      border: none;
      width: 74px;
      height: 74px;
      background: url('~@/assets/images/img-error02.png') no-repeat center /
        cover;
    }
  }
</style>
